<template>
  <div>
    <v-form
      v-if="isShown"
      class="filter white mb-5"
      @submit.prevent="submit"
    >
      <v-container fluid>
        <v-row>
          <v-col cols="2">
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('common.supplier') }}
              </label>
              <v-text-field
                v-model="localFilter.supplier"
                :disabled="isSupplierDisabled"
                hide-details
                solo
              />
            </div>
          </v-col>
          <v-col cols="2">
            <div class="input-block input-block_white">
              <label class="input-block__label required">
                {{ $t('common.plant') }}
              </label>
              <v-select
                v-model="localFilter.plant"
                :items="supplier.plants"
                item-text="plant"
                item-value="plant"
                hide-details
                solo
              />
            </div>
          </v-col>
          <v-col cols="4">
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('common.supplier_type') }}
              </label>
              <v-select
                v-model="localFilter.supplierType"
                :items="supplierTypes"
                hide-details
                clearable
                solo
              />
            </div>
          </v-col>
          <v-col cols="2">
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('common.part') }}
              </label>
              <v-text-field
                v-model="localFilter.part"
                hide-details
                solo
              />
            </div>
          </v-col>
          <v-col cols="2">
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('common.consolidator') }}
              </label>
              <v-text-field
                v-model="localFilter.consolidator"
                hide-details
                solo
              />
            </div>
          </v-col>
          <v-col cols="2">
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('common.analyst') }}
              </label>
              <v-text-field
                v-model="localFilter.analyst"
                hide-details
                solo
              />
            </div>
          </v-col>
          <v-col cols="2">
            <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('common.country') }}
              </label>
              <v-text-field
                v-model="localFilter.country"
                hide-details
                solo
              />
            </div>
          </v-col>
          <v-col
            cols="2"
            class="filter__apply"
          >
            <v-btn
              type="submit"
              :disabled="!localFilter.plant"
              color="primary"
              outlined
              large
              class="filter__apply-button"
            >
              {{ $t('common.apply') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <transition
      name="layout-fade"
      mode="out-in"
    >
      <div
        v-if="noItemsFound"
        class="h4 text-center"
      >
        {{ $t('common.no_data') }}
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'NearestShipmentBySupplierFilter',

  model: {
    prop: 'isShown',
  },

  props: {
    isShown: {
      type: Boolean,
      default: false,
    },

    filters: {
      type: Object,
      required: true,
    },

    noItemsFound: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localFilter: {
        plant: '',
        supplier: '',
        supplierType: '',
        consolidator: '',
        part: '',
        analyst: '',
        country: '',
      },

      supplierTypes: [{
        text: 'Прямой',
        value: 'direct',
      }, {
        text: 'Консолидируемый',
        value: 'consolidated',
      }],
      isSupplierDisabled: false,
    };
  },

  computed: {
    ...mapState(['user', 'supplier']),
    ...mapGetters(['business']),
  },

  watch: {
    localFilter: {
      deep: true,
      handler(val) {
        this.$emit('change', val);
      },
    },
  },

  created() {
    this.init();

    if (!this.business) {
      this.forceASDB();
    }
  },

  methods: {
    init() {
      this.localFilter = { ...this.filter };
    },

    submit() {
      this.$emit('search', this.localFilter);
    },

    forceASDB() {
      this.isSupplierDisabled = true;
      this.$set(this.localFilter, 'supplier', this.user.asdb);
      if (this.supplier && this.supplier.plants) {
        const [plantData] = this.supplier.plants;
        this.$set(this.localFilter, 'plant', (plantData && plantData.plant) || '');
      }
    },
  },
};
</script>
